import React from 'react';
import classNames from 'classnames';

import Dropdown from '../../Dropdown/Dropdown';
import useSearchParams from '../SearchFilters.hooks';

import { parse } from '../../../util/urlHelpers';
import { InlineTextButton } from '../../Button/Button';
import { FormattedMessage } from 'react-intl';

import css from './DropdownFilter.module.css';

const DropdownFilter = props => {
  const {
    className,
    options,
    onChange,
    onValueReset,
    label,
    searchParamName,
    placeholder,
    customIcon,
    classNameLabel,
    disableFiltering,
    disableResetButton = false,
    searchable = false,
  } = props;

  const { handleValueChanged, handleResetFilter, search } = useSearchParams({
    onChange,
    searchParamName,
    searchable,
    onValueReset,
  });

  const searchValue = `${parse(search)[searchParamName]}`;
  return (
    <div className={classNames(css.root, className)}>
      {label && <label>{label}</label>}
      <Dropdown
        className={css.dropdown}
        options={options}
        value={searchValue}
        onChange={handleValueChanged}
        placeholder={placeholder}
        disabled={!options?.length}
        customIcon={customIcon}
        searchable={searchable}
        dropdownInputClassName={classNameLabel || css.input}
        disableFiltering={disableFiltering}
      />
      {parse(search)[searchParamName] && !disableResetButton && (
        <InlineTextButton onClick={handleResetFilter} className={css.resetFilter}>
          <FormattedMessage id="Global.resetFilter" />
        </InlineTextButton>
      )}
    </div>
  );
};

export default DropdownFilter;
